import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelationRepository } from '@/core/domain/cancelation/repositories/cancelation.repository';
import { cancelReservationUseCase } from '../../core/domain/cancelation/usecases/cancelReservation.usecase';
import { CancelationImplRepository } from './cancelation-impl.repository';

const cancelReservationUseCaseFactory = (
    cancelationRepository: CancelationRepository,
) => new cancelReservationUseCase(cancelationRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: cancelReservationUseCase,
            useFactory: cancelReservationUseCaseFactory,
            deps: [CancelationRepository],
        },
        {
            provide: CancelationRepository,
            useClass: CancelationImplRepository,
        },
    ],
})
export class CancelationDataModule {}
